// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3uJV2","actions":"GroupTable_actions__1N4bn","deleteModalFooter":"GroupTable_deleteModalFooter__2s8M-"};